import styled from "styled-components";
import {tokens} from "../../../../theme";

export const ResultsSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ResultText = styled.div`
    font-size: ${tokens.fontSize.sm};
    color: ${({theme}) => theme.palette.text.primary};
    line-height: 1.8;
    white-space: pre-wrap;
    width: 100%;
`;